/* eslint camelcase: 0 */
import { Beacontype, BeacontypeSeed } from '@/infrastructure/network/Legacy/schema'
import { IBeacontypeProps, EmptyBeacontypePropsFactory } from '@/entities/Legacy/Beacontype'

export const toBeacontypeProps = (props: Beacontype): IBeacontypeProps => {
  if (!props) {
    return EmptyBeacontypePropsFactory()
  }

  const { id, name, order } = props
  return {
    id,
    name,
    order
  }
}

export const toBeacontypeSeed = (props: IBeacontypeProps): BeacontypeSeed => {
  const { id, name, order } = props
  return {
    id,
    name,
    order
  }
}
